/* File: assets/ca3-scroll-down.js
   Binds click/keyboard to smoothly scroll to the next section.
*/
(() => {
  const SELECTOR_SECTION = '[data-ca3-scroll-down]';
  const SELECTOR_TRIGGER = '[data-ca3-scroll-down-trigger]';

  const getNextShopifySection = (sectionEl) => {
    // Prefer next .shopify-section after current section wrapper
    let el = sectionEl;
    while (el && el.parentElement) {
      // walk up until we hit a Shopify section root (often the section itself already is)
      if (el.classList && el.classList.contains('shopify-section')) break;
      el = el.parentElement;
      if (el === document.body) break;
    }

    const currentRoot = (el && el.classList && el.classList.contains('shopify-section')) ? el : sectionEl;
    let next = currentRoot.nextElementSibling;

    while (next) {
      if (next.classList && next.classList.contains('shopify-section')) return next;
      next = next.nextElementSibling;
    }
    return null;
  };

  const scrollToElementTop = (targetEl) => {
    const top = targetEl.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top, behavior: 'smooth' });
  };

  const onActivate = (sectionEl) => {
    const nextSection = getNextShopifySection(sectionEl);
    if (nextSection) {
      scrollToElementTop(nextSection);
      return;
    }
    // Fallback: one viewport down
    window.scrollTo({ top: window.pageYOffset + window.innerHeight, behavior: 'smooth' });
  };

  const initOne = (sectionEl) => {
    if (sectionEl.dataset.ca3ScrollDownInitialized === 'true') return;
    sectionEl.dataset.ca3ScrollDownInitialized = 'true';

    const trigger = sectionEl.querySelector(SELECTOR_TRIGGER);
    if (!trigger) return;

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      onActivate(sectionEl);
    });

    trigger.addEventListener('keydown', (e) => {
      // Activate on Enter / Space for accessibility
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onActivate(sectionEl);
      }
    });
  };

  const initAll = () => {
    document.querySelectorAll(SELECTOR_SECTION).forEach(initOne);
  };

  // Initial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  // Shopify theme editor support (dynamic reload)
  document.addEventListener('shopify:section:load', (event) => {
    if (!event || !event.target) return;
    const sectionEl = event.target.querySelector(SELECTOR_SECTION);
    if (sectionEl) initOne(sectionEl);
  });
})();
